import { ApiClientError } from "@/application/errors/ApiClientError";

/**
 * The backend never implemented this endpoint — calls have always failed
 * with 404. Throwing locally preserves the exact UI behavior without the
 * network round-trip, until a product decision implements or removes the
 * feature that calls it.
 */
export function deadEndpoint(method: string, endpoint: string): never {
  throw new ApiClientError({
    message: "HTTP 404: Not Found",
    status: 404,
    code: "NOT_FOUND",
    endpoint,
    method,
  });
}
